// eslint-disable-next-line eslint-comments/disable-enable-pair -- Ignore
/* eslint-disable react/no-array-index-key -- Ignore */
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { withConditionalFeatures } from '@americanexpress/conditional-features';
import { SelectNative, SelectNativeOption } from '@americanexpress/dls-react';
import generateChildAgeDropdownOptions from '../../utils/childAgeDropdownOptionsUtil';
import { useRoomsContext } from '../../contexts/roomsContext';
import {
  hasChildAgeBelowTwoRule,
  hasZeroAndOneAgeLabelsRule,
  isChildrenMaxAgeElevenRule,
} from '../../constants/featureConstants';
import { useConfigContext } from '../../contexts/configContext';

const ChildrenAges = ({
  hasChildAgeBelowTwo,
  hasMaxAgeOfEleven,
  hasZeroAndOneAgeLabels,
  isMultiRoom,
  roomIndex,
}) => {
  const { rooms, updateChildAge } = useRoomsContext();
  const { moduleId, hasInfants } = useConfigContext();

  const { formatMessage } = useIntl();
  const { children } = rooms[roomIndex];

  const childAgeDropdownOptions = generateChildAgeDropdownOptions({
    hasMaxAgeOfEleven,
    hasInfants,
    hasZeroAndOneAgeLabels,
    hasChildAgeBelowTwo,
  });

  const roomId = roomIndex + 1;
  return (
    <div className="row">
      <p className="col-xs-12 dls-black margin-1-tb">
        <b>
          <FormattedMessage id="childs_age_at_end_of_travel_title" />
        </b>
        <br />
        <span
          aria-live="off"
          className="dls-black legal-1"
          id="childAgeAtEndOfTravel"
        >
          {formatMessage({ id: 'child_age_at_end_of_travel' })}
        </span>
      </p>
      {children.map((age, childIndex) => {
        const childId = childIndex + 1;
        const labelHtmlFor = `${moduleId}-room-${roomId}-child-${childId}-age`;

        return (
          <div key={`${roomIndex}_${childIndex}`} className="col-xs-6">
            <div className="form-group">
              <SelectNative
                id={labelHtmlFor}
                status="default"
                label={formatMessage({ id: 'child_age' },
                  { totalChildren: children.length, childIndex: childId })}
                value={age}
                onChange={({ target: { value: childAge } }) => updateChildAge(
                  roomIndex, childIndex, childAge
                )}
                aria-describedby="childAgeAtEndOfTravel"
              >
                {childAgeDropdownOptions.map((item) => (
                  <SelectNativeOption
                    aria-label={formatMessage(
                      { id: 'roomChildAgeAriaLabel' },
                      {
                        isMultiRoom,
                        roomId,
                        childId,
                        childAge: item.value,
                      }
                    )}
                    key={item.value}
                    value={item.value}
                  >
                    {item.label}
                  </SelectNativeOption>
                ))}
              </SelectNative>
            </div>
          </div>
        );
      })}
    </div>
  );
};

ChildrenAges.propTypes = {
  hasChildAgeBelowTwo: PropTypes.bool.isRequired,
  hasMaxAgeOfEleven: PropTypes.bool.isRequired,
  hasZeroAndOneAgeLabels: PropTypes.bool.isRequired,
  isMultiRoom: PropTypes.bool,
  roomIndex: PropTypes.number,
};

ChildrenAges.defaultProps = {
  roomIndex: 0,
};

const mapFeaturesToProps = {
  hasChildAgeBelowTwo: hasChildAgeBelowTwoRule,
  hasMaxAgeOfEleven: isChildrenMaxAgeElevenRule,
  hasZeroAndOneAgeLabels: hasZeroAndOneAgeLabelsRule,
};
const hocChain = compose(withConditionalFeatures({ mapFeaturesToProps }));

export { ChildrenAges as TestableChildrenAges };

export default hocChain(ChildrenAges);
